import * as React from 'react'

function IconRhombusComplete({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={103}
      viewBox="0 0 104 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g
            filter="url(#prefix__filter2_rhombus)"
            strokeMiterlimit={10}
            strokeLinecap="round"
          >
            <path
              d="M45.248 100.876L2 58.113A9.365 9.365 0 002 44.76L45.248 2c3.73 3.688 9.778 3.688 13.504 0L102 44.76a9.365 9.365 0 000 13.353l-43.244 42.763c-3.73-3.688-9.778-3.688-13.508 0z"
              fill="#fff"
              stroke={color}
              strokeWidth={2}
            />
            <path
              d="M9.865 57.285a16.093 16.093 0 001.09-5.847c0-2.034-.375-4.009-1.09-5.847L45.911 9.303a15.8 15.8 0 005.808 1.098c2.02 0 3.982-.377 5.808-1.098l36.046 36.288a16.094 16.094 0 00-1.09 5.847c0 2.034.374 4.01 1.09 5.847L57.527 93.573a15.798 15.798 0 00-5.808-1.097 15.8 15.8 0 00-5.808 1.097L9.865 57.286z"
              fill={color}
              stroke="#fff"
            />
            <path
              d="M64.921 43.011L48.073 59.865l-8.433-8.427"
              stroke="#fff"
              strokeWidth={6}
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <filter
              id="prefix__filter2_rhombus"
              x={0.577}
              y={0.593}
              width={102.845}
              height={101.689}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M45.248 100.876L2 58.113A9.365 9.365 0 002 44.76L45.248 2c3.73 3.688 9.778 3.688 13.504 0L102 44.76a9.365 9.365 0 000 13.353l-43.244 42.763c-3.73-3.688-9.778-3.688-13.508 0z"
            fill="#fff"
            stroke={color}
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M9.865 57.285a16.094 16.094 0 001.09-5.847c0-2.034-.374-4.009-1.09-5.847L45.911 9.303a15.798 15.798 0 005.808 1.098 15.8 15.8 0 005.809-1.098l36.045 36.288a16.094 16.094 0 00-1.09 5.847c0 2.034.375 4.01 1.09 5.847L57.528 93.573a15.8 15.8 0 00-5.809-1.097c-2.02 0-3.982.377-5.808 1.097L9.865 57.286z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M64.921 43.011L48.073 59.865l-8.432-8.427"
            stroke="#219321"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRhombusComplete
